import { render } from "./ProfilePersonal.view.vue?vue&type=template&id=13407d06"
import script from "./ProfilePersonal.view.vue?vue&type=script&lang=js"
export * from "./ProfilePersonal.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__